import { render } from "./VR.vue?vue&type=template&id=477c5b61&scoped=true"
import script from "./VR.vue?vue&type=script&lang=js"
export * from "./VR.vue?vue&type=script&lang=js"

import "./VR.vue?vue&type=style&index=0&id=477c5b61&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477c5b61"]])

export default __exports__